import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SociedadesService } from '../sociedades.service';
import { fuseAnimations } from '../../../../core/animations';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';
import { User } from '../../../../core/modelos/user';
import { Sociedad } from '../../../../core/modelos/sociedad';

@Component({
    selector: 'fuse-sociedades-editar',
    templateUrl: './sociedades-editar.component.html',
    styleUrls: ['./sociedades-editar.component.scss'],
    animations: fuseAnimations
})
export class SociedadesEditarComponent implements OnInit {

    sociedad: Sociedad;
    idSociedad: number;

    // Variable que indica si estamos editando o creando.
    editando = false;
    loading = true;

    // Validación del servidor
    validacion: any;

    // Formulario
    formulario: FormGroup;

    ocultar = true;

    usuarioLogueado: User;

    esAdminBod: boolean;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private sociedadesService: SociedadesService,
        private notificaciones: NotificacionesService,
    ) {
        // Traigo el sociedad por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idSociedad = params['idSociedad'];
        });
    }

    ngOnInit() {
        this.init();
    }

    init() {
        this.usuarioLogueado = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
        this.esAdminBod = this.usuarioLogueado.rol.id === 1;

        if (this.idSociedad) {
            this.editando = true;
            this.getSociedad(this.idSociedad); // TODO: Suscribir para redirigir si no existe

        } else {
            this.loading = false;
            this.crearFormulario();
        }
    }

    getSociedad(id: number) {
        this.sociedadesService.getSociedad(id).subscribe(
            data => {
                if (data.success) {
                    this.sociedad = data.items;
                    this.loading = false;
                    this.crearFormulario();
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Sociedades.SociedadNOObtenido);
                    this.router.navigate(['/sociedades']);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    crearFormulario() {
        if (this.editando) {
            this.formulario = this.fb.group({
                nombre: [this.sociedad.nombre, Validators.required],
            });
        } else {
          if (this.usuarioLogueado.rol.id === 1) {
            this.formulario = this.fb.group({
              nombre: ['', Validators.required],
            });
          } else {
              this.formulario = this.fb.group({
                nombre: ['', Validators.required],
              });
            }
        }
    }

    compare(val1, val2) {
        return val1.id === val2.id;
    }

    actualizarPag(event: boolean) {
        if (event) {
            this.init();
        }
    }

    onSubmit(): void {
        this.loading = true;
        this.sociedad = this.prepararModelo();
        this.sociedad.cliente = this.usuarioLogueado.cliente;
        if (this.editando) {
            this.sociedadesService.updateSociedad(this.sociedad).subscribe(
                data => {
                    if (data.success) {
                        // this.sociedadesService.removeAssetsFromCache();
                        // this.router.navigate(['/sociedades/detalle', data.items.id]);
                        // this.init();
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Sociedades.SociedadEditado);
                        this.router.navigate(['/sociedades']);
                    } else if (data.message) {
                        this.validacion = data.message;
                        this.init();
                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Sociedades.SociedadNOEditado);
                        this.router.navigate(['/sociedades']);
                    }
                },
                err => {
                    this.notificaciones.errorServidor(err.status);
                    this.router.navigate(['/sociedades']);
                    // if (err.error.message) {
                    //     this.validacion = err.error.message;
                    // }
                }
            );

        } else {
            // Al añadir un sociedad, creo una carpeta en el bucket con su nombre
            this.loading = true;
            this.sociedadesService.addSociedad(this.sociedad).subscribe(
                data => {
                    this.loading = false;
                    if (data.success) {
                        // this.sociedadesService.removeAssetsFromCache();
                        // No creo la carpeta si el sociedad no ha sido creado
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Sociedades.SociedadCreado);
                        this.router.navigate(['/sociedades']);
                        // TODO: Alerta de centro creado
                    } else if (data.message) {
                        this.notificaciones.mostrarAviso(data.message);

                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Sociedades.SociedadNOCreado);
                        this.router.navigate(['/sociedades']);
                    }
                },
                error => {
                    this.loading = false;
                    this.notificaciones.errorServidor(error.status);
                    this.router.navigate(['/sociedades']);
                }
            );
        }
    }

    prepararModelo(): Sociedad {
        const formModel = this.formulario.value;

        const saveSociedad: Sociedad = {
            id: this.sociedad ? this.sociedad.id : undefined,
            nombre: formModel.nombre,
        };

        return saveSociedad;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/sociedades/editar/sociedades-editar.component.ts